module.exports = __webpack_public_path__ + "static/img/foot-logo.90cbd21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/foot-logo.png
// module id = 55Qt
// module chunks = 13